import { ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnInit, Output, ViewChild , signal} from '@angular/core';
import { NgbAccordion } from '../../../../../core/wrappers/ngb-accordion';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { PERMISSION_CONSTANT } from '../../../../../constants/permission';
import { Role } from '../../../../../constants/enum/common/role-enum';
import { LocalStorageUtil } from '../../../../../core/utils/local-storage-util';
import { ModalType } from '../../../../../models/common/modal/modal-config';
import { AuthStoreService } from '../../../../../state/modules/auth/auth-store.service';
import { HandoverNotesService } from '../../../../../state/modules/handover-notes/handover-notes.service';
import { FileViewerComponent } from '../../../../shared/components/form-components/components/file-viewer/file-viewer.component';
import { ImageUploadService } from '../../../../shared/components/form-components/components/profile-upload/image-upload.service';
import { ModalBaseClass } from '../../../../shared/components/modals/base_class/modal-base-class';
import { NotificationComponent } from '../../../../shared/components/modals/notification/notification.component';
import { HANDOVER_NOTES_TYPE } from '../../pages/handover-notes/handover-notes.constant';
import { PERMISSIONV2 } from '../../../../../constants/permissionv2/role-permission';


@Component({
  standalone: false,
  selector: 'kt-handover-notes-comment-section',
  templateUrl: './handover-notes-comment-section.component.html',
  styleUrls: ['./handover-notes-comment-section.component.scss']
})
export class HandoverNotesCommentSectionComponent extends ModalBaseClass implements OnInit {


  // emoji
  @HostListener('document:click', ['$event'])
  public onClick(targetElement) {
    if (this.showEmojis()) {
      this.showEmojis.set(false);
    }
  }

  @Input() handoverNoteData;
  @Input() activeTab;

  permissionConstant = PERMISSION_CONSTANT;
  handoverNoteType = HANDOVER_NOTES_TYPE;
  loading = signal(false);
  showPopover = false;
  showComments = false;
  commentForm: UntypedFormGroup;
  loginUserProfile = null;
  commentDataById = [];
  roleRef = Role;
  editComment = null;
  lastComment = null;
  showEmojis = signal(false);
  allowedExtensions = '.jpeg,.jpg,.png';
  @ViewChild('msgInput', { static: false }) messageInput: ElementRef;
  @ViewChild('acc') acc: NgbAccordion;
  subscriptions: Subscription[] = [];
  commentCount = 0;
  userInfo;
  PermissionV2 = PERMISSIONV2


  constructor(
    public modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    private authStoreService: AuthStoreService,
    private imageuploadservice: ImageUploadService,
    public handoverNotesService: HandoverNotesService
  ) {
    super(modalService)
  }


  ngOnInit() {
    this.setFormGroup();
    this.commentCount = this.handoverNoteData.hand_over_note_trg_comment_count;
    this.displayComments()
    this.subscriptions.push(this.authStoreService.selectUser().subscribe(user => {
      if (user && user.user_id) {
        this.userInfo = user;
      }
    }));
    this.loginUserProfile = LocalStorageUtil.getUserRole();
  }

  setFormGroup() {
    this.commentForm = new UntypedFormGroup({
      hand_over_note_comment_text: new UntypedFormControl('', [Validators.required]),
      hand_over_note_comment_upload_1_extension: new UntypedFormControl(null),
      hand_over_note_comment_upload_1: new UntypedFormControl(null),
    });
  }

  displayComments() {
    this.showComments = true;
    this.getComments(this.handoverNoteData);
  }

  getComments(noteData) {
    this.loading.set(true);
    this.subscriptions.push(this.handoverNotesService.getHandoverNoteById(noteData.hand_over_note_id, 'comment').subscribe((data: any) => {
      if (data && data.data && data.data.data && data.data.data.hand_over_note) {
        this.commentDataById = [].concat(data.data.data.hand_over_note.hand_over_note_comment);
        this.commentCount = data.data.data.hand_over_note.hand_over_note_comment.length;
        // A disabled ngb-panel doesn't auto-collapse, so when the last comment is removed
        // the panel stays open showing an empty body. Collapse it whenever the count is 0.
        if (!this.commentCount) {
          this.acc?.collapseAll();
        }
        this.cdr.detectChanges();
        if (this.commentDataById && this.commentDataById.length === 1) {
          this.cdr.detectChanges();
        }
      }
      this.loading.set(false);
    }, err => {
      this.loading.set(false);
    }));
  }

  commentInputHandler(event) {
    this.commentForm.get('hand_over_note_comment_text').setValue(event.target.innerHTML);
  }

  addEmoji(event) {
    const messageInputEle = this.messageInput.nativeElement;
    messageInputEle.innerHTML = `${messageInputEle.innerHTML}${event.emoji.native}`;
    this.commentForm.get('hand_over_note_comment_text').setValue(messageInputEle.innerHTML);
  }

  pasteHandler(event) {
    let paste = (event.clipboardData || (<any>window).clipboardData).getData('text');
    if (!paste) {
      event.preventDefault();
    }
  }

  toggleEmojis() {
    setTimeout(() => {
      this.showEmojis.update(v => !v);
    });
  }

  editCommentClickHandler(comment) {
    this.editComment = comment;
    this.commentForm.get('hand_over_note_comment_text').setValue(comment.hand_over_note_comment_text);
    this.messageInput.nativeElement.innerHTML = comment.hand_over_note_comment_text;
    if (comment.hand_over_note_comment_upload_1) {
      this.showPopover = true;
      this.commentForm.get('hand_over_note_comment_upload_1').setValue(comment.hand_over_note_comment_upload_1);
      this.commentForm.get('hand_over_note_comment_upload_1_extension').setValue(comment.hand_over_note_comment_upload_1_extension);
    }
  }

  addCommentHandler() {
    this.showPopover = false;
    const payload = this.commentForm.value;
    if(this.commentForm.invalid){
      return;
    }
    if (payload.hand_over_note_comment_text && payload.hand_over_note_comment_text.length || payload.hand_over_note_comment_upload_1) {
      payload.hand_over_note_comment_fk_hand_over_note_id = +this.handoverNoteData.hand_over_note_id;
    }
    if (this.editComment) {
      payload.hand_over_note_comment_id = this.editComment.hand_over_note_comment_id;
      this.lastComment = payload;
      this.subscriptions.push(this.handoverNotesService.updateHandoverNoteComment(payload).subscribe(data => {
        if (data && data.success) {
          const commentIndex = ((this.handoverNoteData && this.handoverNoteData.hand_over_note_comments) || []).findIndex(x => x.hand_over_note_comment_id == this.editComment.hand_over_note_comment_id);
          if (commentIndex > -1) {
            ((this.handoverNoteData && this.handoverNoteData.hand_over_note_comments) || [])[commentIndex] = { ...((this.handoverNoteData && this.handoverNoteData.hand_over_note_comments) || [])[commentIndex], ...data.data.data.hand_over_note_comments };
          }
        }
        this.getComments(this.handoverNoteData);
        this.clearCommentClickHandler();
      }));
    } else {
      this.lastComment = payload;
      this.subscriptions.push(this.handoverNotesService.addHandoverNoteComment(payload).subscribe((data: any) => {
        if (data.success) {
          this.commentForm.reset({});
          this.messageInput.nativeElement.innerHTML = '';
          this.getComments(this.handoverNoteData);
          this.clearCommentClickHandler();
        }
        this.loading.set(false);
      }, err => {
        this.loading.set(false);
      }));
    }
  }

  clearCommentClickHandler() {
    this.editComment = null;
    this.showPopover = false;
    this.messageInput.nativeElement.innerHTML = null;
    this.commentForm.reset({});
  }

  deleteCommentClickHandler(comment) {
    this.loading.set(true);
    this.subscriptions.push(this.handoverNotesService.deleteHandoverNoteComment(comment.hand_over_note_comment_id).subscribe((data: any) => {
      if (data.success) {
        this.getComments(this.handoverNoteData);
      }
      this.loading.set(false);
    }, err => {
      this.loading.set(false);
    }));
  }

  /** Click on Delete Comment
   * @param deleteCommentConfirmation - button click for deleting comment
   */
  deleteCommentConfirmation(comment) {
    // tslint:disable-next-line: no-use-before-declare
    const modalRef = this.modalService.open(NotificationComponent);
    modalRef.componentInstance.options = {
      type: ModalType.DELETE,
      title: 'Confirm',
      message: 'Are you sure you want to delete this Comment?',
    };
    modalRef.result.then((data) => {
      if (data && data.STATUS === 'delete') {
        this.deleteCommentClickHandler(comment);
      }
    }, (error) => { });
  }

  commentFileViewerHandler(fileUrl) {
    this.openPopUp(FileViewerComponent, { fileUrl },
      { centered: true, size: 'xl', keyboard: true, backdrop: 'static' },
    );
  }

  deleteUploadedFileHandler() {
    this.showPopover = false;
    this.commentForm.get('hand_over_note_comment_upload_1_extension').setValue(null);
    this.commentForm.get('hand_over_note_comment_upload_1').setValue(null);
  }

  fileChange(event) {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const formData = new FormData();
      if (!this.allowedExtensions.includes(file.name.split('.').pop()) || file.size / 1024 / 1024 > 5) {
        return;
      }
      formData.append('file', file);
      this.imageuploadservice.uploadImage(formData).subscribe((res) => {
        if (res.status === 200) {
          this.commentForm.get('hand_over_note_comment_upload_1').setValue(res.data.FileUpload.path);
          this.commentForm.get('hand_over_note_comment_upload_1_extension').setValue(file.type);
          this.showPopover = true;
        } else {
          this.showPopover = false;
        }
        // setValue/showPopover set inside an HTTP callback don't reliably tick CD;
        // without this the upload preview stays blank until the next click.
        // Mirrors client-task-comments / news-feed-comment.
        this.cdr.markForCheck();
      });
    }
  }

  showPanel(data) {
    // this.commentDataById = [];
    if (data.nextState) {
      this.setFormGroup();
      this.getComments(this.handoverNoteData)
    }
  }
}
